import React, { Fragment } from 'react';
import Price from './price';
import './index.scss';

// 样品采购
export default function BuySamples(props) {
  const {
    productId,
    skuSample,
    productShippingTemplateId,
    productSamplingType,
    i18n,
    companyId,
    detailEncryptId,
  } = props;

  const bizType = () => {
    switch (productSamplingType) {
      case 'requestSampleFree':
        return '21';
      case 'orderSample':
        return '22';
      case 'requestSample':
        return '20';
      default:
        break;
    }
  };

  const echoFreeSample = () => {
    switch (productSamplingType) {
      case 'requestSampleFree':
        return i18n['mainAction_sample_free'];
      case 'orderSample':
        return i18n['mainAction_sample_order'];
      case 'requestSample':
        return i18n['mainAction_sample_request'];
      default:
        return i18n['btnGetSample'];
    }
  };

  const renderSku = (item, i) => {
    let contentTpl = null;
    if (item.type === 'COLOR') {
      contentTpl = (
        <span
          style={{
            backgroundColor: item.color,
            display: 'inline-block',
            width: '22px',
            height: '22px',
            verticalAlign: 'text-bottom',
            borderRadius: '4px',
          }}
        />
      );
    } else if (item.type === 'IMAGE') {
      contentTpl = (
        <img
          style={{
            backgroundColor: '#FF9999',
            display: 'inline-block',
            width: '22px',
            height: '22px',
            verticalAlign: 'text-bottom',
            borderRadius: '4px',
          }}
          src={`${item.smallImage}`}
          alt="sample-image"
        />
      );
    } else {
      contentTpl = <span key={i}>{item.name}</span>;
    }

    return (
      <Fragment key={i}>
        {i > 0 ? <span> , </span> : null}
        {contentTpl}
      </Fragment>
    );
  };

  const renderSample = () => {
    if (skuSample && skuSample.length > 0) {
      const firstSku = skuSample[0];
      return [
        <div id="detail-sample-promotion" key="d1" />,
        <div
          key="d2"
          className="sample-attr"
          data-sku-id={firstSku.id}
          style={{
            marginBottom: '4px',
          }}
        >
          {firstSku.values &&
            firstSku.values.map((item, i) => renderSku(item, i))}
        </div>,
        <Price key="price" {...props} firstSku={firstSku} />,
      ];
    } else if (productShippingTemplateId) {
      return [
        <div id="detail-sample-promotion" key="promotion" />,
        <div className="ma-request-sourcing-lite" key="souceLite">
          <Price {...props} />
        </div>,
      ];
    } else {
      return (
        <div className="ma-request-sourcing-lite">
          <a
            className="ma-request"
            data-type={productSamplingType}
            href={`//message.alibaba.com/msgsend/sampleOrder.htm?productIds_f=${detailEncryptId}&mloca=${productSamplingType}_en_detail_detail&bizType=${bizType()}`}
            data-domdot={`id:25853,sid:${companyId},pid:'${productId}',ext:'other=${productSamplingType}'`}
            target="_blank"
            data-spm="dsample"
          >
            <i className="item-icons ui2-icon ui2-icon-box" />
            <span
              dangerouslySetInnerHTML={{
                __html: echoFreeSample(),
              }}
            />
          </a>
        </div>
      );
    }
  };

  return (
    <dl className="do-entry-item sample">
      <dt className="do-entry-item-key" title={i18n['btnGetSample.sample']}>
        {i18n['btnGetSample.sample']}:
      </dt>
      <dd className="do-entry-item-val" title="sample">
        {renderSample()}
      </dd>
    </dl>
  );
}
